import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `RegistroAlimentacion/addAlimentacion`, method: 'POST', body: values, token: token})
}
